export const INDIA_ISO2 = 'IN';

const CATEGORY_PRICE_KEYS = {
    marketing: 'marketing_price',
    utility: 'utility_price',
    authentication: 'authentication_price',
    service: 'service_price',
};

/**
 * India domestic sell row from login sell_rates, with pricing_model fallback for older sessions.
 *
 * @param {object|null|undefined} userData
 * @returns {object|null}
 */
export function getIndiaSellRow(userData) {
    const sellRates = Array.isArray(userData?.sell_rates) ? userData.sell_rates : [];
    const fromSellRates = sellRates.find((row) => row?.country_iso2 === INDIA_ISO2);
    if (fromSellRates) {
        return fromSellRates;
    }

    const legacy = userData?.pricing_model;
    if (!legacy) {
        return null;
    }

    return {
        country_iso2: INDIA_ISO2,
        marketing_price: legacy.marketing_price,
        utility_price: legacy.utility_price,
        service_price: legacy.service_price,
        authentication_price: legacy.authentication_price,
    };
}

/**
 * @param {object|null|undefined} userData
 * @returns {boolean}
 */
export function hasBillingPricing(userData) {
    return getIndiaSellRow(userData) !== null;
}

/**
 * @param {object|null|undefined} userData
 * @param {string} messageType marketing | utility | authentication | service
 * @returns {number}
 */
export function getCategoryPrice(userData, messageType = 'utility') {
    const row = getIndiaSellRow(userData);
    if (!row) {
        return 0;
    }

    const key = CATEGORY_PRICE_KEYS[messageType] || CATEGORY_PRICE_KEYS.marketing;
    return Number(row[key] || 0);
}

/**
 * @param {object|null|undefined} userData
 * @returns {number}
 */
export function getPriceAlert(userData) {
    return Number(userData?.pricing_model?.price_alert ?? 0);
}

/**
 * Legacy-shaped object for components that expect marketing_price, utility_price, etc.
 *
 * @param {object|null|undefined} userData
 * @returns {object|null}
 */
export function getIndiaPricingShape(userData) {
    const row = getIndiaSellRow(userData);
    if (!row) {
        return null;
    }

    return {
        marketing_price: Number(row.marketing_price || 0),
        utility_price: Number(row.utility_price || 0),
        service_price: Number(row.service_price || 0),
        authentication_price: Number(row.authentication_price || 0),
        price_alert: getPriceAlert(userData),
    };
}
